import { ICcypair, ISO4217 } from '@alk/currency';
import { ISettingsPartialRecord } from '../services/message-adapters/persistence-adapter';
import { PadConfigExtended } from '../interfaces';
import { Tenor } from '@alk/dates';
import { DATA_01 as TRADING_QUANTITIES } from './trading-quantities.data';

const pads: Array<PadConfigExtended> = [
    {
        'id': '88d72fe0-9fc3-4e75-82ac-017e4a169ca7',
        'date': 'SP' as Tenor,
        'instrument': {
            'symbol': 'EURGBP' as ICcypair,
            'roundLot': 1,
            'minimumTradeVolume': 500000,
            'fractionSize': 4,
            'extraDigitSupport': true,
            'extraDigitSize': 1,
            'settlementPeriodInDays': 2,
            'quotesTrendOnly': false,
            'holidays': [],
        },
        'productType': 'spot',
        'spotType': 'full',
        'pendingType': 'limit',
        'tradedCurrency': 'EUR' as ISO4217,
        'expiryType': 'gtc',
        'triggerPrice': 0,
        'allInstruments': [
            {
                'symbol': 'GBPUSD' as ICcypair,
                'roundLot': 1,
                'minimumTradeVolume': 1,
                'fractionSize': 4,
                'extraDigitSupport': true,
                'extraDigitSize': 1,
                'settlementPeriodInDays': 2,
                'quotesTrendOnly': false,
                'holidays': [],
                'type': 'spot',
            },
            {
                'symbol': 'USDMXN' as ICcypair,
                'roundLot': 1,
                'minimumTradeVolume': 1,
                'fractionSize': 4,
                'extraDigitSupport': true,
                'extraDigitSize': 1,
                'settlementPeriodInDays': 2,
                'quotesTrendOnly': false,
                'holidays': [],
                'type': 'spot',
            },
            {
                'symbol': 'EURGBP' as ICcypair,
                'roundLot': 1,
                'minimumTradeVolume': 500000,
                'fractionSize': 4,
                'extraDigitSupport': true,
                'extraDigitSize': 1,
                'settlementPeriodInDays': 2,
                'quotesTrendOnly': false,
                'holidays': [],
                'type': 'spot',
            },
            {
                'symbol': 'EURUSD' as ICcypair,
                'roundLot': 1,
                'minimumTradeVolume': 1,
                'fractionSize': 4,
                'extraDigitSupport': true,
                'extraDigitSize': 1,
                'settlementPeriodInDays': 2,
                'quotesTrendOnly': false,
                'holidays': [
                    {
                        'value': new Date('2022-05-19T00:00:00Z'),
                        'reason': '',
                    },
                    {
                        'value': new Date('2022-05-13T00:00:00Z'),
                        'reason': '',
                    },
                    {
                        'value': new Date('2022-05-19T00:00:00Z'),
                        'reason': '',
                    },
                    {
                        'value': new Date('2022-05-13T00:00:00Z'),
                        'reason': '',
                    },
                ],
                'type': 'forward',
            },
            {
                'symbol': 'EURCAD' as ICcypair,
                'roundLot': 1,
                'minimumTradeVolume': 1,
                'fractionSize': 4,
                'extraDigitSupport': true,
                'extraDigitSize': 1,
                'settlementPeriodInDays': 2,
                'quotesTrendOnly': false,
                'holidays': [],
                'type': 'forward',
            },
        ],
        'isStartRequested': true,
        'instruments': [
            {
                'symbol': 'GBPUSD' as ICcypair,
                'roundLot': 1,
                'minimumTradeVolume': 1,
                'fractionSize': 4,
                'extraDigitSupport': true,
                'extraDigitSize': 1,
                'settlementPeriodInDays': 2,
                'quotesTrendOnly': false,
                'holidays': [],
                'type': 'spot',
            },
            {
                'symbol': 'USDMXN' as ICcypair,
                'roundLot': 1,
                'minimumTradeVolume': 1,
                'fractionSize': 4,
                'extraDigitSupport': true,
                'extraDigitSize': 1,
                'settlementPeriodInDays': 2,
                'quotesTrendOnly': false,
                'holidays': [],
                'type': 'spot',
            },
            {
                'symbol': 'EURGBP' as ICcypair,
                'roundLot': 1,
                'minimumTradeVolume': 500000,
                'fractionSize': 4,
                'extraDigitSupport': true,
                'extraDigitSize': 1,
                'settlementPeriodInDays': 2,
                'quotesTrendOnly': false,
                'holidays': [],
                'type': 'spot',
            },
        ],
        'farQuantity': 2000000,
    },
];

export const USER_SETTINGS: ISettingsPartialRecord = {
    blotterSelectedTab: '"kondor"',
    readNotifications: '[]',
    clickMode: '"click"',
    pads: JSON.stringify(pads),
    selectedClientId: '1',
    selectedRightBarIdx: '2',
    tradingEnabled: 'true',
    selectedSetting: '"click-and-confirm"',
    tradingQuantities: JSON.stringify(TRADING_QUANTITIES),
};
